import { linkToSignOut } from "$routes/_lib/links";
import { Box, Button, styled, Typography } from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";
import { Link } from "react-router-dom";
import {
  EPOCUS_BORDER,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";
import { EpocusThemeProvider, epocusTheme } from "./epocus-theme-provider";

const PageRoot = styled(Box)({
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  maxWidth: 600,
  margin: "0 auto",
  [epocusTheme.breakpoints.up("sm")]: {
    padding: 24,
  },
});

const Card = styled(Box)({
  backgroundColor: EPOCUS_WHITE,
  borderRadius: 12,
  padding: 16,
  border: `1px solid ${EPOCUS_BORDER}`,
  display: "flex",
  flexDirection: "column",
  gap: 12,
});

const Title = styled(Typography)({
  fontSize: rem(20),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

const Body = styled(Typography)({
  fontSize: rem(14),
  color: EPOCUS_TEXT_SECONDARY,
});

export const ProgramSetupPending: FC = () => (
  <EpocusThemeProvider>
    <PageRoot>
      <Card>
        <Title>Your program isn't set up yet</Title>
        <Body>
          You're not part of an ePOCUS program, so there's nothing to show here
          yet. Someone from your team will be in touch to finish setting you up.
        </Body>
        <Button
          component={Link}
          to={linkToSignOut()}
          variant="outlined"
          color="primary"
          startIcon={<ExitToApp />}
          style={{ alignSelf: "flex-start", minHeight: 44 }}
        >
          Log out
        </Button>
      </Card>
    </PageRoot>
  </EpocusThemeProvider>
);
